import React, { useEffect } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { Element } from '@codesandbox/components';
import { dashboard as dashboardUrls } from '@codesandbox/common/lib/utils/url-generator';
import css from '@styled-system/css';
import { useAppState, useActions } from 'app/overmind';
import { Home } from './routes/Home';
import { Templates } from './routes/Templates';
import { Deleted } from './routes/Deleted';
import { Drafts } from './routes/Drafts';
import { Recent } from './routes/Recent';
import { Shared } from './routes/Shared';
import { Liked } from './routes/Liked';
import { AlwaysOn } from './routes/AlwaysOn';
import { All } from './routes/All';
import { Repositories } from './routes/Repositories';
import { Search } from './routes/Search';
import { Settings } from './routes/Settings';
import { NewTeam } from './routes/Settings/NewTeam';
import { Discover } from './routes/Discover';
import { Album } from './routes/Discover/Album';
import { Curate } from './routes/Discover/Curate';
import { CommunitySearch } from './routes/Discover/CommunitySearch';
import { BetaRepositoriesPage } from './routes/Beta';

export const Content = withRouter(({ history }) => {
  const { dashboard } = useActions();
  const { activeTeam, dashboard: dashboardState } = useAppState();

  useEffect(() => {
    dashboard.dashboardMounted();
  }, [dashboard]);

  useEffect(() => {
    const removeListener = history.listen(() => {
      dashboard.blacklistedTemplatesCleared();
      dashboard.orderByReset();
    });

    return () => {
      removeListener();
    };
  }, [history, history.listen, dashboard]);

  const isFeatureFlagBeta = !!dashboardState.featureFlags.find(
    e => e.name === 'beta'
  );

  return (
    <Element
      css={css({
        width: '100%',
        height: '100%',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
      })}
    >
      <Switch>
        <Route
          path="/dashboard/beta"
          /**
           * Wrap the component instead of the whole route, as the
           * feature-flag query takes a few ms to load, and meanwhile the Route
           * redirect the page because the route hasn't been registered yet
           */
          component={isFeatureFlagBeta ? BetaRepositoriesPage : () => null}
        />
        <Route path="/dashboard/home" component={Home} />
        <Route path="/dashboard/drafts" component={Drafts} />
        <Route path="/dashboard/all/:path*" component={All} />
        <Route path="/dashboard/templates" component={Templates} />
        <Route path="/dashboard/repositories/:path*" component={Repositories} />
        <Route path="/dashboard/always-on" component={AlwaysOn} />
        <Route path="/dashboard/recent" component={Recent} />
        <Route path="/dashboard/deleted" component={Deleted} />
        <Route path="/dashboard/shared" component={Shared} />
        <Route path="/dashboard/liked" component={Liked} />
        <Route path="/dashboard/search" component={Search} />
        <Route path="/dashboard/discover/search" component={CommunitySearch} />
        <Route path="/dashboard/discover/curate" component={Curate} />
        <Route path="/dashboard/discover/:id" component={Album} />
        <Route path="/dashboard/discover" component={Discover} />
        <Route path="/dashboard/settings" component={Settings} />
        {/* old dashboard - redirects: */}
        <Route path="/dashboard/trash" component={Deleted} />
        <Route path="/dashboard/sandboxes/:path*" component={All} />
        <Route path="/dashboard/teams/new" component={NewTeam} />
        <Redirect to={dashboardUrls.home(activeTeam)} />
      </Switch>
    </Element>
  );
});
